// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2dJNN","col":"styles_col__1YFqB"};